import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiTopicData = () => {
    const { allStrapiTopic } = useStaticQuery(graphql`
        query {
            allStrapiTopic(sort: {fields: card_title, order: ASC}) {
                nodes {
                    id
                    slug
                    title
                    card_title
                    thumbnail {
                        alternativeText
                        localFile {
                            childImageSharp {
                                gatsbyImageData(width: 646 height: 284, aspectRatio:2.27)
                            }
                        }
                    }
                    series {
                        title
                        card_title
                        slug
                    }
                }
            }
        }
    `)

    return { allStrapiTopic }
}
